import {
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import {
  AssociadoSearchResponse,
  AssociadoUpdateRequest,
} from 'api/Assessor/associado';
import { DropdownIcon } from 'components/Icons';
import { FlagColaborador } from 'helpers/enums/TipoColaborador';
import { formatCPFOrCNPJ } from 'helpers/utils/cpfCnpjMask';
import ErrorHandler from 'helpers/utils/ErrorHandler';
import translation from 'locales/translation';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { assessorActionAtualizarAssociado } from 'store/modules/assessor/actions';
import { IReducer } from 'store/Reducer';
import useStyle from './style';

interface Props {
  associados: AssociadoSearchResponse;
  onChangeItem: (changes: AssociadoUpdateRequest) => void;
}

export default function Tabela({ associados, onChangeItem }: Props) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { atualizandoAssociado, procurandoAssociado } = useSelector(
    (state: IReducer) => state.assessor
  );

  const handleChange = useCallback(
    (request: AssociadoUpdateRequest) => {
      dispatch(
        assessorActionAtualizarAssociado(request, ErrorHandler, () => {
          onChangeItem(request);
          toast.success(translation.VinculoAssociado.sucessoUpdate);
        })
      );
    },
    [dispatch, onChangeItem]
  );

  const tableHeads = useMemo(() => {
    return [
      translation.VinculoAssociado.tableHead.cpfCnpf,
      translation.VinculoAssociado.tableHead.nome,
      translation.VinculoAssociado.tableHead.coop,
      translation.VinculoAssociado.tableHead.agencia,
      translation.VinculoAssociado.tableHead.conta,
      translation.VinculoAssociado.tableHead.nucleo,
      translation.VinculoAssociado.tableHead.colaborador,
    ];
  }, []);

  return (
    <TableContainer className={classes.root}>
      <Table>
        <TableHead className={classes.box}>
          <TableRow>
            {tableHeads.map((head, i) => (
              <TableCell
                key={head}
                className={classes.title}
                align={i > 1 ? 'center' : 'left'}
              >
                {head}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody className={classes.box}>
          {associados.map((associado) => (
            <TableRow key={associado.id}>
              <TableCell align='left' className={classes.data}>
                {formatCPFOrCNPJ(associado.cpfCnpj)}
              </TableCell>
              <TableCell align='left' className={classes.data}>
                {associado.nome}
              </TableCell>
              <TableCell align='center' className={classes.data}>
                {associado.codigoCooperativa}
              </TableCell>
              <TableCell align='center' className={classes.data}>
                {associado.codigoAgencia}
              </TableCell>
              <TableCell align='center' className={classes.data}>
                {associado.numeroConta}
              </TableCell>
              <TableCell align='center' className={classes.data}>
                {associado.numeroNucleo}
              </TableCell>
              <TableCell align='center' className={classes.data}>
                <TextField
                  SelectProps={{
                    IconComponent: () => (
                      <DropdownIcon className={classes.selectIcon} />
                    ),
                    value: associado.flgColaborador,
                    onChange: (e) =>
                      handleChange({
                        oidAssociado: associado.id,
                        flgColaborador: e.target.value as FlagColaborador,
                      }),
                  }}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  disabled={atualizandoAssociado || procurandoAssociado}
                  fullWidth
                  select
                >
                  <MenuItem
                    value={FlagColaborador.NaoColaborador}
                    selected={
                      associado.flgColaborador ===
                      FlagColaborador.NaoColaborador
                    }
                  >
                    {translation.VinculoAssociado.flagColaborador[0]}
                  </MenuItem>
                  <MenuItem
                    value={FlagColaborador.Colaborador}
                    selected={
                      associado.flgColaborador === FlagColaborador.Colaborador
                    }
                  >
                    {translation.VinculoAssociado.flagColaborador[1]}
                  </MenuItem>
                  <MenuItem
                    value={FlagColaborador.Conselheiro}
                    selected={
                      associado.flgColaborador === FlagColaborador.Conselheiro
                    }
                  >
                    {translation.VinculoAssociado.flagColaborador[2]}
                  </MenuItem>
                </TextField>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
